import { useEffect, useState } from "react"
import { Flex, Wrapper } from "./AllCollection";
import StorieItem from "./StoriesItem";
import { $stories, $deeplinkStoryId, getStories, setDeeplinkStoryId } from "../../../../components/store/stories";
import { useUnit } from "effector-react";
import { IStorie } from "../../../../components/types/stories";
import StoryViewer from "./StoryViewer";


const Stories = () => {
  const data = useUnit($stories);
  const deeplinkStoryId = useUnit($deeplinkStoryId);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ selectedStory, setSelectedStory ] = useState<IStorie | null>(null);

  useEffect(()=>{
    if(!data.length){
      setIsLoading(true);
      getStories().then(()=>setIsLoading(false));
    }
  },[])

  useEffect(() => {
    if (deeplinkStoryId && data.length) {
      const story = data.find(s => s.id === deeplinkStoryId);
      if (story) {
        setSelectedStory(story);
      } else {
        setSelectedStory({ id: deeplinkStoryId, title: '', content_type: 'article', is_active: true, order_index: 0, has_content: true, category: null, external_url: null, expires_at: null });
      }
      setDeeplinkStoryId(null);
    }
  }, [deeplinkStoryId, data])

  return (
    <Wrapper>
      <Flex>
        {data.map(item => <StorieItem key={item.id} data={item} onOpen={setSelectedStory}/>)}
      </Flex>
      <StoryViewer
        story={selectedStory}
        isOpen={selectedStory !== null}
        onClose={() => setSelectedStory(null)}
      />
    </Wrapper>
  )
}

export default Stories
